export function isVNode(node) {
  return (
    node !== null &&
    typeof node === 'object' &&
    Object.prototype.hasOwnProperty.call(node, 'componentOptions')
  )
}

//获取元素距离浏览器顶部的距离
export function getElementTop(element) {
  if (element.offsetParent) {
    return getElementTop(element.offsetParent) + element.offsetTop
  }
  return element.offsetTop
}
